import { mmFetchWithResponse } from './mmFetchWithResponse';

const creditApi = {
    massCredit: async (creditValue, reason, customerFile) => {
        const formData = new FormData();
        formData.append('creditValue', creditValue);
        formData.append('reason', reason);
        formData.append('customerFile', customerFile);

        const url = `api/credits/v1/mass`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
};

export { creditApi };
